/**
 * ShareData Factory
 */
(function (itxApp) {

    'use strict';

    angular.module('itxApp.common')
        .service('ItxShareDataFct', ItxShareDataFct);

    /**
     * Share data properties
     * @constructor
     */
    function ItxShareDataFct() {
        var dataObj = {};
        return {
            add: function (prop, value) {
                dataObj[prop] = value;
            },
            remove: function (prop) {
                delete dataObj[prop];
            },
            get: function (prop) {
                return dataObj[prop];
            }
        };
    }

    /** Public */
    itxApp.common.ItxShareDataFct = ItxShareDataFct;

})(window.itxApp);
